var _ = require('../utils/lib.js');
var Popup = require('./pop-up.js');
var Options = require('./options.js');
var View = require('./view.js');
window.CartJS = require('shopify-cartjs');

var GiftOptions = function () {
  this.selectors = {
    giftOptions: '.gift-options',
    giftOptionModal: '.gift-options__modal',
    giftOptionActions: '[data-gift-option-action]',
    giftOptionMessage: '[data-gift-option-message]'
  };
  this.classes = {
    giftOptionsOpen: 'gift-options--open'
  };
  this.addingToCart = false;

  this.popup = new Popup(this.selectors, this.classes);
  this.view = new View(giftOptions.locales, giftOptions.moneyFormat);
  this.options = new Options(giftOptions.products, giftOptions.cart.items);
  this.init();
};

GiftOptions.prototype.init = function () {
  CartJS.init(giftOptions.cart, { 'dataAPI': false });
  this._addEventListeners();
  this.options.createGiftOption(); // add a blank gift option to begin with so we don't have any empty state
  this.renderGiftOptions();

  if (this._canOpenGiftOptions()) {
   this.popup.open();
  }
};

GiftOptions.prototype.renderGiftOptions = function () {
  var _this = this,
    modal = document.querySelector(this.selectors.giftOptionModal),
    modalScrollTop = modal.scrollTop,
    data = {
      options: this.options,
      cart: giftOptions.cart,
      adding_to_cart: this.addingToCart
    };

  this.view.render(this.selectors.giftOptionModal, 'GiftOptions', data, function () {
    // Stop modal scrolling back to top after render
    // we replace the modal node durring render so get the new one and set it's scroll to be that of the previous ones.
    var modal = document.querySelector(_this.selectors.giftOptionModal);
    modal.scrollTop = modalScrollTop;
  });
};

GiftOptions.prototype.addToCart = function () {
  this.addingToCart = true;
  this.renderGiftOptions();
  // add items to cart
  _.each(this.options.items, function (option) {
    var giftProducts = option.giftProductsForCart();
    _.each(giftProducts, function (giftProduct) {
      var properties = {
        '_optionID': option.id,
        'Products': option.lineItemTitles
      };
      if (giftProduct.message != '') {
        properties['Gift Message'] = giftProduct.message;
      }

      CartJS.addItem(giftProduct.selected_variant.id, 1, properties, {
        error: function(jqXHR, textStatus, errorThrown) {
          console.log('error',jqXHR, textStatus, errorThrown);
        }
      });
    });
  }, this);
};

GiftOptions.prototype.reloadCart = function () {
  location.reload();
};

// Private
GiftOptions.prototype._addEventListeners = function () {
  var _this = this;
  $(document).on('cart.requestComplete', function () {
    _this.addingToCart = false;
    _this.reloadCart();
  });

  _.documentEventListener('click', this.selectors.giftOptionActions+':not(input):not(select)', function (e, target) {
    e.preventDefault();
    this._onGiftOptionActions(target);
  }, this);

  _.documentEventListener('change', this.selectors.giftOptionActions+':not(a):not(button)', function (e, target) {
    this._onGiftOptionActions(target);
  }, this);

  _.documentEventListener('keyup', this.selectors.giftOptionMessage, function (e, target) {
    _this._updateGiftOptionMessage(target);
  },this);
};

GiftOptions.prototype._onGiftOptionActions = function (actionEle) {
  var actionAttr = _.selectorToStr(this.selectors.giftOptionActions);
  var action = actionEle.getAttribute(actionAttr);
  switch (action) {
    case 'open':
      this.popup.open();
      break;
    case 'close':
      this.popup.close();
      break;
    case 'add':
      this.addToCart();
      break;
    case 'create':
      this.options.createGiftOption();
      this.renderGiftOptions();
      break;
    case 'remove':
      var optionID = actionEle.getAttribute('data-option');
      this.options.removeGiftOption(optionID);
      this.renderGiftOptions();
      break;
    case 'addGiftOptionProduct':
      var optionData = {
        id: actionEle.getAttribute('data-option'),
        giftProduct: actionEle.getAttribute('data-gift-product'),
        selected: actionEle.checked
      };
      this.options.addGiftOptionProduct(optionData);
      this.renderGiftOptions();
      break;
    case 'setGiftOptionProductVariant':
      var optionData = {
        id: actionEle.getAttribute('data-option'),
        giftProduct: actionEle.getAttribute('data-gift-product'),
        variantID: actionEle.value
      };
      this.options.setGiftOptionProductVariant(optionData);
      this.renderGiftOptions();
      break;
    case 'addLineItemToGiftOption':
      var optionData = {
        id: actionEle.getAttribute('data-option'),
        lineItemID: actionEle.value
      };
      this.options.addLineItemToGiftOption(optionData);
      this.renderGiftOptions();
      break;
    case 'removeLineItemFromGiftOption':
      var optionData = {
        id: actionEle.getAttribute('data-option'),
        lineItemID: actionEle.getAttribute('data-line-item-id')
      };
      this.options.removeLineItemFromGiftOption(optionData);
      this.renderGiftOptions();
      break;
    default:
      this.popup.toggle();
  }
};

GiftOptions.prototype._updateGiftOptionMessage = function (messageEle) {
  var optionData = {
    id: messageEle.getAttribute('data-option'),
    giftProduct: messageEle.getAttribute('data-gift-product'),
    message: messageEle.value
  };
  this.options.updateGiftOptionProductMessage(optionData);
};

GiftOptions.prototype._canOpenGiftOptions = function () {
  // If there are no items that can be added to gifts or we already have gift products in the cart then don't open the popup
  var cartItemTypes = giftOptions.cart.items.map(function (item) {
    return item.product_type;
  });
  return this.options.line_items.length > 0 && !_.inArray(this.options.giftProductType, cartItemTypes);
};

module.exports = GiftOptions;
